var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6307_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.418 9.47044L9.4763 23.4121",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0508 6.67129L13.6508 8.07129",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 9.80932L9.12182 12.5977",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 16.0507L16.0532 23.7973C13.5798 26.2707 12.3432 26.2823 9.89315 23.8323L4.16482 18.104C1.71482 15.654 1.72649 14.4173 4.19982 11.944L11.9465 4.19734C14.4198 1.72401 15.6565 1.71234 18.1065 4.16234L23.8348 9.89067C26.2848 12.3407 26.2848 13.5657 23.7998 16.0507Z",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 10.2354H0V27.9997H12.8333V10.2354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40538 27.9995C3.09983 27.9995 0.414062 25.6278 0.414062 22.7106V19.653C0.414062 19.3142 0.695035 19.0332 1.03385 19.0332C1.37267 19.0332 1.65365 19.3142 1.65365 19.653C1.65365 21.8181 3.69483 23.4544 6.40538 23.4544C9.11594 23.4544 11.1571 21.8181 11.1571 19.653C11.1571 19.3142 11.4381 19.0332 11.7769 19.0332C12.1157 19.0332 12.3967 19.3142 12.3967 19.653V22.7106C12.3967 25.6278 9.71094 27.9995 6.40538 27.9995ZM1.65365 22.8015C1.71149 24.9915 3.81878 26.7599 6.40538 26.7599C8.99198 26.7599 11.0993 24.9915 11.1571 22.8015C10.0828 23.9667 8.38045 24.694 6.40538 24.694C4.43031 24.694 2.73621 23.9667 1.65365 22.8015Z",
    fill: "#ABABC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40538 20.5652C4.12455 20.5652 2.07509 19.5405 1.07516 17.8877C0.645441 17.1853 0.414062 16.3672 0.414062 15.5242C0.414062 14.1029 1.05038 12.7641 2.19907 11.7559C3.32295 10.7725 4.81871 10.2354 6.40538 10.2354C7.99205 10.2354 9.47954 10.7725 10.6117 11.7476C11.7604 12.7641 12.3967 14.1029 12.3967 15.5242C12.3967 16.3672 12.1653 17.177 11.7356 17.8877C10.7357 19.5405 8.68621 20.5652 6.40538 20.5652ZM6.40538 11.4749C5.11621 11.4749 3.9097 11.9047 3.00894 12.698C2.13296 13.4583 1.65365 14.4665 1.65365 15.5242C1.65365 16.144 1.81891 16.7225 2.13294 17.2431C2.91801 18.5323 4.55427 19.3256 6.40538 19.3256C8.25649 19.3256 9.89275 18.524 10.6778 17.2431C11.0001 16.7225 11.1571 16.144 11.1571 15.5242C11.1571 14.4665 10.6778 13.4583 9.79358 12.6815C8.89282 11.9047 7.69455 11.4749 6.40538 11.4749Z",
    fill: "#ABABC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40538 24.6972C2.9924 24.6972 0.414062 22.532 0.414062 19.6562V15.5242C0.414062 12.6071 3.09983 10.2354 6.40538 10.2354C7.99205 10.2354 9.47954 10.7725 10.6117 11.7476C11.7604 12.7641 12.3967 14.1029 12.3967 15.5242V19.6562C12.3967 22.532 9.81837 24.6972 6.40538 24.6972ZM6.40538 11.4749C3.78573 11.4749 1.65365 13.293 1.65365 15.5242V19.6562C1.65365 21.8213 3.69483 23.4576 6.40538 23.4576C9.11594 23.4576 11.1571 21.8213 11.1571 19.6562V15.5242C11.1571 14.4665 10.6778 13.4583 9.79358 12.6815C8.89282 11.9047 7.69455 11.4749 6.40538 11.4749Z",
    fill: "#ABABC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6307_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/loan.1ac746028e7235857b0c419131d9e5fe.svg";
export { ForwardRef as ReactComponent };